import mapResponseToPriceGrid from './mappers/mapResponseToPriceGrid'

export default function(api: GlobalFetch) {
  return async function(
    objectId,
    calendarId,
    startDate,
    finishDate,
    group = 1,
    selectedRooms = [],
  ) {
    let roomsQuery = ''
    if (selectedRooms.length) {
      roomsQuery = `/?${selectedRooms
        .map(roomId => `id_room[]=${roomId}`)
        .join('&')}`
    }

    const response = await api.fetch(
      `/api/v2/price/index/id_object/${objectId}/id_calendar/${calendarId}/start/${startDate}/end/${finishDate}/group/${group}${roomsQuery}`,
    )
    return await handleResponse(response)
  }
}

export async function handleResponse(response) {
  const json: IData = await response.json()
  return json.items ? json.items.map(mapResponseToPriceGrid) : []
}

interface IData {
  messages: string[]
  items: IPriceGridData[]
}

export interface IPriceGridData {
  id_room: string
  prices: IPriceData[]
  restrictions: IRestrictionsData[]
}

export interface IPriceData {
  standard: string[]
  weekend: string[]
  short: string[]
  long: string[]
  kids: {
    kid_id: number
    age_from: number
    age_to: number
    standard: string
    weekend: string
    short: string
    long: string
  }[]
  extrabed: {
    standard: string
    weekend: string
    short: string
    long: string
  }
  price_day_from: string
  price_day_to: string
}

export interface IRestrictionsData {
  restriction_day_from: string
  restriction_day_to: string
  restriction_min_stay: number
  restriction_min_stay_thru: number
  restriction_max_stay: number
  restriction_max_stay_thru: number
  restriction_exact_stay: number
  restriction_close_at_arrival: number
  restriction_close_at_departure: number
  restriction_min_before_arrival: number
  restriction_max_before_arrival: number
}
